define([
    "../externalFreightModule",
    "text!./externalFreightOptionsModal.html"
], function (externalFreightModule, template) {
    "use strict";
    return externalFreightModule.provider("externalFreightOptionsModal", [function () {
        this.$get = ["$http", "$modal", "loadingService", "remoteExceptionHandler", "externalFreightServiceUrl", "$translate",
            function ($http, $modal, loadingService, remoteExceptionHandler, externalFreightServiceUrl, $translate) {
                return function (restExternalFreights, context) {
                    return $modal.open({
                        template: template,
                        size: "lg",
                        backdrop: "static",
                        controller: ["$scope", "messagesModal", function ($scope, messagesModal) {

                            $scope.restExternalFreights = restExternalFreights;

                            $scope.filter = {
                                carrier: "all",
                                operationType: "all"
                            };

                            $scope.availableCarriers = [{
                                value: "all",
                                label: "external.freight.modal.carrier.all"
                            }];

                            $scope.availableOperationTypes = [{
                                value: "all",
                                label: "external.freight.modal.operation.type.all"
                            }];

                            var carriersMap = {};
                            var operationTypesMap = {};

                            for (var i = 0; i < $scope.restExternalFreights.length; i++) {
                                var restExternalFreight = $scope.restExternalFreights[i];

                                if (!carriersMap[restExternalFreight.carrier]) {
                                    carriersMap[restExternalFreight.carrier] = true;
                                    $scope.availableCarriers.push({
                                        value: restExternalFreight.carrier,
                                        label: restExternalFreight.carrier
                                    });
                                }

                                if (!operationTypesMap[restExternalFreight.operationType]) {
                                    operationTypesMap[restExternalFreight.operationType] = true;
                                    $scope.availableOperationTypes.push({
                                        value: restExternalFreight.operationType,
                                        label: restExternalFreight.operationType
                                    });
                                }
                            }

                            $scope.getOperationTypeLabel = function (type) {
                                if (type.value === "all") {
                                    return $translate.instant("external.freight.modal.operation.type.all");
                                }
                                return type.label ? type.label : "-";
                            };

                            $scope.applyFilter = function () {
                                $scope.selectedFreight = null;
                                $scope.filteredFreights = $scope.restExternalFreights.filter(function (restExternalFreight) {
                                    var carrierMatch = $scope.filter.carrier === "all" ||
                                        restExternalFreight.carrier === $scope.filter.carrier;

                                    var typeMatch = $scope.filter.operationType === "all" ||
                                        restExternalFreight.operationType === $scope.filter.operationType;

                                    return carrierMatch && typeMatch;
                                });
                            };
                            $scope.applyFilter();

                            $scope.selectExternalFreight = function () {
                                return loadingService($http.post(externalFreightServiceUrl.getSelectExternalFreight(), $scope.selectedFreight)
                                    .catch(remoteExceptionHandler())
                                    .then(function (response) {
                                        return messagesModal("dialog.success", response.data.messages).then(function () {
                                            context.refilter();
                                            return $scope.$close();
                                        });
                                    }));
                            };

                            $scope.setExternalFreight = function (selectedFreight) {
                                $scope.selectedFreight = selectedFreight;
                            };


                            $scope.hasRecords = function () {
                                return $scope.restExternalFreights.length > 0 && $scope.filteredFreights.length > 0;
                            };
                        }]
                    });
                };
            }];
    }]);
});